import React, { useRef } from 'react';
import {
	LoadingContainer,
	NoData,
} from '../../Dashboard/ChartsList/ChartsList.styles';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsHeatmap from 'highcharts/modules/heatmap';
import { useCommonSuppliersContext } from 'contexts/CategoryInsightsKpi/CommonSupplierProvider';
import Pagination from 'components/Pagination/Pagination';
HighchartsHeatmap(Highcharts);

const CommonSupplierByBU = () => {
	const {
		isLoading,
		data,
		options,
		currentPage,
		setCurrentPage,
		pageSize,
	} = useCommonSuppliersContext();

	const chartRef = useRef();

	return (
		<>
			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact
							highcharts={Highcharts}
							options={options}
							ref={chartRef}
						/>
					)}
				</>
			)}

			{!isLoading && (
				<>
					<Pagination
						currentPage={currentPage}
						totalCount={options.transformDataLength}
						pageSize={pageSize}
						onPageChange={page => setCurrentPage(page)}
						position="center"
					/>
				</>
			)}
		</>
	);
};

export default CommonSupplierByBU;
